import React from 'react';
import { styled } from '@mui/material/styles';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import { Typography } from '@mui/material';
import PropTypes from 'prop-types';

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800]
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.mode === 'light' ? '#1a90ff' : '#308fe8'
  }
}));

export default function CustomProgressBar({ from, to, label }) {
  const percentageValue = (from / to) * 100;
  return (
    <div style={{ marginTop: 15 }}>
      <Typography style={{ marginBottom: 10 }}>
        {label} {from} to {to}
      </Typography>
      <BorderLinearProgress variant="determinate" value={percentageValue} />
    </div>
  );
}

CustomProgressBar.propTypes = {
  from: PropTypes.number,
  to: PropTypes.number,
  label: PropTypes.string
};
